import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface AccountHeaderProps {
  name: string | null | undefined;
  email: string | null | undefined;
  avatarUrl: string | null | undefined;
}

function getInitials(name: string | null | undefined): string {
  if (!name) {
    return 'U';
  }

  const parts = name.trim().split(' ');
  if (parts.length === 0 || !parts[0]) {
    return 'U';
  }

  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }

  const lastPart = parts[parts.length - 1];
  return (
    parts[0].charAt(0) + (lastPart ? lastPart.charAt(0) : '')
  ).toUpperCase();
}

export function AccountHeader({ name, email, avatarUrl }: AccountHeaderProps) {
  const initials = getInitials(name);

  return (
    <div className="flex flex-col items-center space-y-4 py-6">
      <Avatar className="h-20 w-20">
        <AvatarImage src={avatarUrl ?? undefined} alt={name ?? 'Avatar'} />
        <AvatarFallback className="bg-primary/10 text-primary text-2xl font-medium">
          {initials}
        </AvatarFallback>
      </Avatar>
      <div className="text-center">
        {name && (
          <h2 className="text-foreground text-xl font-semibold">{name}</h2>
        )}
        {email && <p className="text-muted-foreground text-sm">{email}</p>}
      </div>
    </div>
  );
}
